import { P as ProgressBar, d as defineCustomElement$1 } from './p-9a56e546.js';
const OwcProgressBar = ProgressBar;
const defineCustomElement = defineCustomElement$1;
export { OwcProgressBar, defineCustomElement };